var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquareArrowUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 2V3.33333H3.33333V12.6667H12.6667V9.33333H14V13.3333C14 13.7015 13.7015 14 13.3333 14H2.66667C2.29848 14 2 13.7015 2 13.3333V2.66667C2 2.29848 2.29848 2 2.66667 2H6.66667ZM11.7239 3.33333H8.66667V2H14V7.33333H12.6667V4.27614L8 8.9428L7.0572 8L11.7239 3.33333Z",
    fill: "#0F62FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareArrowUp);
export default __webpack_public_path__ + "static/media/square-arrow-up.c7e631de2933b790522e9f55248472db.svg";
export { ForwardRef as ReactComponent };